var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../../config/config';
import { VisitorTripCommand } from '../../../../commands/pagination.query.command';
import { MatFieldComponent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../../common/components/facebook.login.button/facebook.login.button.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { PlaceService } from '../../../../services/place.service';
import { ShareService } from '../../../../services/share.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorTripNotifyAddOrRemoveItemStore, VisitorTripStore, } from '../../../../stores/visitor.calendar.store';
import { ImageComponent } from '../../../../common/components/image/image.component';
var TripFloatDetailComponent = /** @class */ (function (_super) {
    __extends(TripFloatDetailComponent, _super);
    function TripFloatDetailComponent(router, imageService, formBuilder, visitorTripStore, allFrontendSettingsStore, notifyAddOrRemoveItemStore, visitorApiService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.formBuilder = formBuilder;
        _this.visitorTripStore = visitorTripStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.visitorApiService = visitorApiService;
        _this.activatedRoute = activatedRoute;
        _this.placeSource = 'google';
        _this.showOperation = false;
        _this.showAddToTrip = false;
        _this.isShowDetail = false;
        _this.isInAnyTrip = false;
        _this.detailDate = null;
        _this.detailTime = null;
        _this.isMultiDateEvent = false;
        _this.isFeedLoaded = false;
        _this.isShowNearbyPlaces = false;
        _this.canShowGoogleReviews = false;
        _this.isShowFeedForMobile = false;
        _this.trancatedEventTimes = [];
        _this.trancatedEventTimesText = [];
        _this.userID = null;
        _this.facebookLogo = config.facebook.logo;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.onClosing = new EventEmitter();
        _this.onPlaceFeedsClosing = new EventEmitter();
        _this.onShown = new EventEmitter();
        _this.onPlaceFeedsRetrieved = new EventEmitter();
        return _this;
    }
    TripFloatDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, tripId = _a.tripId;
        this.hubName = hubName;
        this.urlTripId = tripId;
        this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);
        if (tripId && tripId !== 'tour-list') {
            this.visitorApiService.getUserTripByTripID(this.hubName, tripId).subscribe(function (trip) {
                _this.urlTripFromUserID = trip ? trip.userFacebookId : null;
            });
        }
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
            }
        });
    };
    Object.defineProperty(TripFloatDetailComponent.prototype, "isShowAddtoMyTrip", {
        get: function () {
            return this.showAddToTrip && !this.item['isOnlineEvent'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripFloatDetailComponent.prototype, "isShowViewFBPostBtn", {
        get: function () {
            return (!this.isFeedLoaded && this.type === 'place' && this.item.hostLink && this.item.hostLink.indexOf('facebook') >= 0);
        },
        enumerable: true,
        configurable: true
    });
    TripFloatDetailComponent.prototype.showNearByPlaces = function () {
        this.isShowNearbyPlaces = true;
    };
    TripFloatDetailComponent.prototype.gotoPlace = function (item) {
        // this.data = new TripDetailModalData(item, 'place', this.hubName, null, null, false, null);
        //
        // setTimeout(() => {
        //     this.imgComp && this.imgComp.updateImage(this.data.item.cover && this.data.item.cover.source);
        //     this.imgViewer && this.imgViewer.updateImage(this.data.item.cover && this.data.item.cover.source);
        //     this.setGooglePlaceInfoAndFBPosts();
        // });
        this.showDetails({ item: item, feedType: 'place' }, '100%', '0');
    };
    TripFloatDetailComponent.prototype.showFBPostsForMobile = function () {
        this.isShowFeedForMobile = true;
    };
    TripFloatDetailComponent.prototype.showDetails = function (item, left, top, height) {
        var _this = this;
        // if (!this.isDraggable || this.isMobile) {
        //     return;
        // }
        this.isFeedLoaded = false;
        this.canShowGoogleReviews = false;
        this.isShowNearbyPlaces = false;
        if (this.isShowDetail && this.item === item.item) {
            this.closeDetails();
            return;
        }
        if (item.feedType === 'event') {
            this.isMultiDateEvent = item.item.eventTimes && item.item.eventTimes.length > 1;
            if (item.item.startTimeText) {
                this.detailDate = EventTimeService.getDateFromTimeText(item.item.startTimeText);
                this.detailTime = EventTimeService.getTimeFromTimeText(item.item.startTimeText);
                if (this.isMultiDateEvent) {
                    this.detailDate =
                        EventTimeService.getDateFromTimeText(item.item.startTimeText) +
                            ' - ' +
                            EventTimeService.getDateFromTimeText(item.item.endTimeText);
                }
            }
            else if (item.item.startTime) {
                this.detailDate = EventTimeService.getDateFromTime(item.item.startTime);
                this.detailTime = EventTimeService.getTimeFromTime(item.item.startTime);
                if (this.isMultiDateEvent) {
                    this.detailDate =
                        EventTimeService.getDateFromTime(item.item.startTime) +
                            ' - ' +
                            EventTimeService.getDateFromTime(item.item.endTime);
                }
            }
            else {
                this.detailDate = null;
                this.detailTime = null;
            }
            if (item.item.eventTimes && item.item.eventTimes.length > 3) {
                this.trancatedEventTimes = item.item.eventTimes.slice(0, 3);
            }
            else if (item.item.eventTimes && item.item.eventTimes.length <= 3) {
                this.trancatedEventTimes = item.item.eventTimes.slice(0, item.item.eventTimes.length);
            }
            if (item.item.eventTimesText && item.item.eventTimesText.length > 3) {
                this.trancatedEventTimesText = item.item.eventTimesText.slice(0, 3);
            }
            else if (item.item.eventTimesText && item.item.eventTimesText.length <= 3) {
                this.trancatedEventTimesText = item.item.eventTimesText.slice(0, item.item.eventTimes.length);
            }
        }
        item.item.description && this.setDescription(item.item.description);
        this.item = item.item;
        this.type = item.feedType;
        this.isShowDetail = true;
        setTimeout(function () {
            _this.detailsPanel.nativeElement.style.top = top;
            _this.detailsPanel.nativeElement.style.left = left; //'calc(25% - 8px)';
            _this.detailsPanel.nativeElement.style.opacity = 1;
            _this.detailsPanel.nativeElement.style.transition = '0.6s';
            if (height) {
                _this.detailsPanel.nativeElement.style.height = height;
            }
            _this.placeFeeds = [];
            _this.placeFeedPaging = null;
            if (item.feedType === 'place') {
                _this.setGooglePlaceInfoAndFBPosts();
            }
            _this.itemImage.updateImage(_this.item.cover ? _this.item.cover.source : null);
            setTimeout(function () {
                if (_this.detailsPanel) {
                    _this.detailsPanel.nativeElement.style.transition = 'none';
                }
            }, 600);
        });
        this.onShown.emit({ item: item.item, type: item.feedType });
    };
    TripFloatDetailComponent.prototype.setGooglePlaceInfoAndFBPosts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, matched;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.item.socialName === 'google')) return [3 /*break*/, 4];
                        _a = this;
                        return [4 /*yield*/, PlaceService.getGooglePlaceDetails(this.item, this.hubName, this.visitorApiService)];
                    case 1:
                        _a.googleInfo = _b.sent();
                        if (this.googleInfo) {
                            this.item.website = this.googleInfo.website;
                            this.item.phone = this.googleInfo.formatted_phone_number || this.googleInfo.phone;
                            if (((this.googleInfo.reviews && this.googleInfo.reviews.length) ||
                                (this.googleInfo.googleReviews && this.googleInfo.googleReviews.length)) &&
                                this.featuresToggle.googleReviews) {
                                this.isFeedLoaded = true;
                                // google reviews panel has an animation showing, so wait for a while to display the content
                                setTimeout(function () {
                                    _this.canShowGoogleReviews = true;
                                }, 700);
                            }
                        }
                        if (!this.featuresToggle.facebookPosts) return [3 /*break*/, 3];
                        return [4 /*yield*/, PlaceService.matchToFacebookPlace(this.item, this.hubName, this.visitorApiService)];
                    case 2:
                        matched = _b.sent();
                        if (matched.fbId) {
                            this.getFacebookPlaceFeed(matched.fbId);
                            this.setDescription(matched.place.description || matched.place.about);
                        }
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.getFacebookPlaceFeed();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TripFloatDetailComponent.prototype.closeFeeds = function () {
        if (!this.isFeedLoaded) {
            this.closeDetails();
            return;
        }
        this.isFeedLoaded = false;
        this.onPlaceFeedsClosing.emit();
        this.placeFeeds = [];
        this.closeDetails();
    };
    TripFloatDetailComponent.prototype.closeDetails = function () {
        var _this = this;
        if (!this.detailsPanel) {
            return;
        }
        if (this.isMobile && this.isShowFeedForMobile) {
            this.isShowFeedForMobile = false;
            this.setDescription(this.item.description);
            return;
        }
        this.detailsPanel.nativeElement.style.transition = '0.6s';
        this.detailsPanel.nativeElement.style.left = '75%';
        this.detailsPanel.nativeElement.style.opacity = 0;
        this.onClosing.emit();
        setTimeout(function () {
            if (_this.detailsPanel) {
                _this.detailsPanel.nativeElement.style.transition = 'none';
            }
        }, 600);
        setTimeout(function () {
            _this.isShowDetail = false;
        }, 1000);
    };
    TripFloatDetailComponent.prototype.showMoreTimes = function () {
        if (this.trancatedEventTimes.length === 3) {
            this.trancatedEventTimes = this.item.eventTimes;
            if (this.item.eventTimesText) {
                this.trancatedEventTimesText = this.item.eventTimesText;
            }
        }
        else {
            this.trancatedEventTimes = this.item.eventTimes.slice(0, 3);
            if (this.item.eventTimesText && this.item.eventTimesText.length > 3) {
                this.trancatedEventTimesText = this.item.eventTimesText.slice(0, 3);
            }
        }
    };
    TripFloatDetailComponent.prototype.showOnMap = function ($event) {
        $event && $event.stopPropagation();
        this.closeDetails();
        this.visitorTripStore.tripCommand.next(new VisitorTripCommand(this.item));
    };
    TripFloatDetailComponent.prototype.setDescription = function (description) {
        var _this = this;
        if (description) {
            setTimeout(function () {
                if (_this.description) {
                    _this.description.nativeElement.innerHTML = description;
                }
            }, 100);
        }
        else {
            setTimeout(function () {
                if (_this.description) {
                    _this.description.nativeElement.innerHTML = '';
                }
            }, 100);
        }
    };
    TripFloatDetailComponent.prototype.getFacebookPlaceFeed = function (id) {
        var _this = this;
        id = id ? id : ShareService.getFacebookPlaceId(this.item.hostLink);
        if (id &&
            ((this.item.socialName === 'facebook' && FacebookLoginButtonComponent.isUserLoggedWithFacebook) ||
                (this.item.socialName === 'google' && this.featuresToggle.facebookPosts))) {
            var url = config.facebook.graphApi.placePosts
                .replace('${accessToken}', config.facebook.approvedApps[0])
                .replace('${placeId}', id);
            FB.api(url, function (response) {
                _this.placeFeedPaging = response.paging;
                if (!!response.error) {
                    //console.error(response.error);
                    _this.placeFeedPaging = null;
                    return;
                }
                _this.updatePlaceFeeds(response.data);
            });
        }
    };
    TripFloatDetailComponent.prototype.getNextFacebookPlaceFeed = function (event) {
        var _this = this;
        FB.api(this.placeFeedPaging.next, function (response) {
            event.complete();
            _this.placeFeedPaging = response.paging;
            if (!!response.error) {
                console.error(response.error);
                return;
            }
            _this.updatePlaceFeeds(_this.placeFeeds.concat(response.data));
        });
    };
    TripFloatDetailComponent.prototype.updatePlaceFeeds = function (placeFeeds) {
        // this.placeFeeds = placeFeeds.filter(x => x.message && x.from && x.actions && x.actions.length >= 2);
        this.placeFeeds = placeFeeds.filter(function (x) { return x.message; });
        this.placeFeeds.forEach(function (x) {
            x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
        if (this.placeFeeds && this.placeFeeds.length) {
            this.onPlaceFeedsRetrieved.emit({ item: this.item });
        }
        //setTimeout(() => {
        if (this.placeFeeds && this.placeFeeds.length) {
            this.isFeedLoaded = true;
        }
        //});
    };
    return TripFloatDetailComponent;
}(BaseComponent));
export { TripFloatDetailComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.float.detail/trip.float.detail.component.ts.pre-build-optimizer.js